import React from "react";
import { getField } from "../../util/DynamicItemUtils";
import Truncate from "react-truncate";
import ReactDOMServer from "react-dom/server";

export default function PageNode({ item }: any) {
  return (
    <div>
      <p className="lead-text-lt">{getField(item, "contenttypelabel")}</p>
      <h3>
        <a href={getField(item, "pageurl")}>{getField(item, "title")}</a>
      </h3>
      {getField(item, "parentpagetitle") && (
        <p className="parent-page-title">{getField(item, "parentpagetitle")}</p>
      )}
      <div className="hawk-summary-text">
        <Truncate lines={3}>
          {ReactDOMServer.renderToString(getField(item, "content"))}
        </Truncate>
      </div>
      <br />
      <p>
        <a href={getField(item, "pageurl")} className="hawk-read-more">
          Read More
        </a>
      </p>
    </div>
  );
}
